module.exports = __webpack_public_path__ + "static/media/app-2.101f8bc7.jpg";